export default {
  search: {
    title: 'Hvor vil du reise?',
    departureDate: 'Utreise',
    returnDate: 'Retur',
    continue: 'Fortsett',
  },
  travelPlanner: {
    search: {
      origin: 'Fra',
      destination: 'Til',
      switchDirection: 'Bytt retning',
    },
  },
}
